import { useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { Field, IconAlert, Spinner } from "../components/ui";

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [fields, setFields] = useState({});
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setFields({});
    setBusy(true);

    try {
      await signIn(email, password);
      // AuthProvider sets the user; the router swaps to the app shell.
    } catch (err) {
      setError(err.message);
      setFields(err.fields || {});
      setBusy(false);
    }
  }

  return (
    <div className="login-page">
      <aside className="login-aside">
        <div className="login-rule">
          <span style={{ background: "var(--red)" }} />
          <span style={{ background: "var(--green)" }} />
          <span style={{ background: "#fff" }} />
        </div>
        <h2>
          HR Leaders
          <br />
          Circle UAE
        </h2>
        <p>
          The control room for the community — members, Leader Spotlights, gatherings and RSVPs,
          all in one place.
        </p>
      </aside>

      <main className="login-main">
        <div className="login-card">
          <h1>Sign in</h1>
          <p>Admin access only.</p>

          {error && (
            <div className="login-alert">
              <IconAlert style={{ width: 16, height: 16, flex: "0 0 auto", marginTop: 1 }} />
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <Field label="Email" error={fields.email}>
              <input
                className={`input ${fields.email ? "has-error" : ""}`}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                autoComplete="username"
                autoFocus
                required
              />
            </Field>

            <Field label="Password" error={fields.password}>
              <input
                className={`input ${fields.password ? "has-error" : ""}`}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••••"
                autoComplete="current-password"
                required
              />
            </Field>

            <button type="submit" className="btn btn-primary" disabled={busy}>
              {busy && <Spinner />}
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
